import { action } from '../../lib/client';
export function sendAction<T=unknown>(name:string,payload:Record<string,unknown>={}){return action<T>(name,payload,'member',name==='tasksList'||name==='taskClaimReward'?AbortSignal.timeout(120000):undefined);}
